<template>
	<div id="bubbles">
		<div class="bubble x1"></div>
		<div class="bubble x2"></div>
		<div class="bubble x3"></div>
		<div class="bubble x4"></div>
		<div class="bubble x5"></div>
		<div class="bubble x6"></div>
		<div class="bubble x7"></div>
		<div class="bubble x8"></div>
		<div class="bubble x9"></div>
		<div class="bubble x10"></div>
	</div>
</template>
<script>
export default {
	name: "bubbles"
}
</script>
<style>
#bubbles {
	height: 100%;
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	z-index: 1;
}

#bubbles {
	padding: 100px 0
}
.bubble {
	width: 5vw;
	height: 5vw;
	background: rgba(255, 255, 255, 0.05);
	border-radius: 10vw;
	-moz-border-radius: 10vw;
	-webkit-border-radius: 10vw;
	position: absolute;
}

.x1 {
	left: 85vw;
	color: yellow;
	-webkit-transform: scale(0.9);
	-moz-transform: scale(0.9);
	-o-transform: scale(0.9);
	transform: scale(0.9);
	opacity: 0.2;
	-webkit-animation: moveBubbles 4s linear infinite, sideWays 4s ease-in-out infinite alternate;
	-moz-animation: moveBubbles 4s linear infinite, sideWays 4s ease-in-out infinite alternate;
	-o-animation: moveBubbles 4s linear infinite, sideWays 4s ease-in-out infinite alternate;
	animation: moveBubbles 4s linear infinite, sideWays 4s ease-in-out infinite alternate;
}

.x2 {
	left: 5vw;
	-webkit-transform: scale(0.6);
	-moz-transform: scale(0.6);
	-o-transform: scale(0.6);
	transform: scale(0.6);
	opacity: 0.5;
	-webkit-animation: moveBubbles 6s linear infinite, sideWays 5s ease-in-out infinite alternate;
	-moz-animation: moveBubbles 6s linear infinite, sideWays 5s ease-in-out infinite alternate;
	-o-animation: moveBubbles 6s linear infinite, sideWays 5s ease-in-out infinite alternate;
	animation: moveBubbles 6s linear infinite, sideWays 5s ease-in-out infinite alternate;
}

.x3 {
	left: 35vw;
	-webkit-transform: scale(0.8);
	-moz-transform: scale(0.8);
	-o-transform: scale(0.8);
	transform: scale(0.8);
	opacity: 0.3;
	-webkit-animation: moveBubbles 5s linear infinite, sideWays 4s ease-in-out infinite alternate;
	-moz-animation: moveBubbles 5s linear infinite, sideWays 4s ease-in-out infinite alternate;
	-o-animation: moveBubbles 5s linear infinite, sideWays 4s ease-in-out infinite alternate;
	animation: moveBubbles 5s linear infinite, sideWays 4s ease-in-out infinite alternate;
}

.x4 {
	left: 47vw;
	-webkit-transform: scale(0.75);
	-moz-transform: scale(0.75);
	-o-transform: scale(0.75);
	transform: scale(0.75);
	opacity: 0.35;
	-webkit-animation: moveBubbles 8s linear infinite, sideWays 2s ease-in-out infinite alternate;
	-moz-animation: moveBubbles 8s linear infinite, sideWays 2s ease-in-out infinite alternate;
	-o-animation: moveBubbles 8s linear infinite, sideWays 2s ease-in-out infinite alternate;
	animation: moveBubbles 8s linear infinite, sideWays 2s ease-in-out infinite alternate;
}

.x5 {
	left: 15vw;
	-webkit-transform: scale(0.8);
	-moz-transform: scale(0.8);
	-o-transform: scale(0.8);
	transform: scale(0.8);
	opacity: 0.3;
	-webkit-animation: moveBubbles 5s linear infinite, sideWays 1s ease-in-out infinite alternate;
	-moz-animation: moveBubbles 5s linear infinite, sideWays 1s ease-in-out infinite alternate;
	-o-animation: moveBubbles 5s linear infinite, sideWays 1s ease-in-out infinite alternate;
	animation: moveBubbles 5s linear infinite, sideWays 1s ease-in-out infinite alternate;
}

.x6 {
	left: 73vw;
	-webkit-transform: scale(0.4);
	-moz-transform: scale(0.4);
	-o-transform: scale(0.4);
	transform: scale(0.4);
	opacity: 0.2;
	-webkit-animation: moveBubbles 4s linear infinite, sideWays 4s ease-in-out infinite alternate;
	-moz-animation: moveBubbles 4s linear infinite, sideWays 4s ease-in-out infinite alternate;
	-o-animation: moveBubbles 4s linear infinite, sideWays 4s ease-in-out infinite alternate;
	animation: moveBubbles 4s linear infinite, sideWays 4s ease-in-out infinite alternate;
}

.x7 {
	left: 67vw;
	-webkit-transform: scale(0.6);
	-moz-transform: scale(0.6);
	-o-transform: scale(0.6);
	transform: scale(0.6);
	opacity: 0.5;
	-webkit-animation: moveBubbles 11s linear infinite, sideWays 5s ease-in-out infinite alternate;
	-moz-animation: moveBubbles 11s linear infinite, sideWays 5s ease-in-out infinite alternate;
	-o-animation: moveBubbles 11s linear infinite, sideWays 5s ease-in-out infinite alternate;
	animation: moveBubbles 11s linear infinite, sideWays 5s ease-in-out infinite alternate;
}

.x8 {
	left: 56vw;
	-webkit-transform: scale(0.8);
	-moz-transform: scale(0.8);
	-o-transform: scale(0.8);
	transform: scale(0.8);
	opacity: 0.3;
	-webkit-animation: moveBubbles 9s linear infinite, sideWays 4s ease-in-out infinite alternate;
	-moz-animation: moveBubbles 9s linear infinite, sideWays 4s ease-in-out infinite alternate;
	-o-animation: moveBubbles 9s linear infinite, sideWays 4s ease-in-out infinite alternate;
	animation: moveBubbles 9s linear infinite, sideWays 4s ease-in-out infinite alternate;
}

.x9 {
	left: 20vw;
	-webkit-transform: scale(0.75);
	-moz-transform: scale(0.75);
	-o-transform: scale(0.75);
	transform: scale(0.75);
	opacity: 0.35;
	-webkit-animation: moveBubbles 4.5s linear infinite, sideWays 2s ease-in-out infinite alternate;
	-moz-animation: moveBubbles 4.5s linear infinite, sideWays 2s ease-in-out infinite alternate;
	-o-animation: moveBubbles 4.5s linear infinite, sideWays 2s ease-in-out infinite alternate;
	animation: moveBubbles 4.5s linear infinite, sideWays 2s ease-in-out infinite alternate;
}

.x10 {
	left: 33vw;
	-webkit-transform: scale(0.4);
	-moz-transform: scale(0.4);
	-o-transform: scale(0.4);
	transform: scale(0.4);
	opacity: 0.3;
	-webkit-animation: moveBubbles 11.3s linear infinite, sideWays 5s ease-in-out infinite alternate;
	-moz-animation: moveBubbles 11.3s linear infinite, sideWays 5s ease-in-out infinite alternate;
	-o-animation: moveBubbles 11.3s linear infinite, sideWays 5s ease-in-out infinite alternate;
	animation: moveBubbles 11.3s linear infinite, sideWays 5s ease-in-out infinite alternate;
}

@-webkit-keyframes moveBubbles {
	0% {
		top: 100vh;
		opacity: 0;
	}

	50% {
		opacity: 1;
	}

	100% {
		top: 0vh;
		opacity: 0;
	}
}

@-webkit-keyframes sideWays {
	0% {
		margin-left: 0px;
	}

	100% {
		margin-left: 5vw;
	}
}

@-moz-keyframes moveBubbles {
	0% {
		top: 100vh;
		opacity: 0;
	}

	50% {
		opacity: 1;
	}

	100% {
		top: 0vh;
		opacity: 0;
	}
}

@-moz-keyframes sideWays {
	0% {
		margin-left: 0px;
	}

	100% {
		margin-left: 5vw;
	}
}

@-o-keyframes moveBubbles {
	0% {
		top: 100vh;
		opacity: 0;
	}

	50% {
		opacity: 1;
	}

	100% {
		top: 0vh;
		opacity: 0;
	}
}

@-o-keyframes sideWays {
	0% {
		margin-left: 0px;
	}

	100% {
		margin-left: 5vw;
	}
}

@keyframes moveBubbles {
	0% {
		top: 100vh;
		opacity: 0;
	}

	50% {
		opacity: 1;
	}

	100% {
		top: 0vh;
		opacity: 0;
	}
}

@keyframes sideWays {
	0% {
		margin-left: 0px;
	}

	100% {
		margin-left: 5vw;
	}
}

</style>